import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"subsets\":[\"latin\"],\"variable\":\"--font-base\",\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"Mr_Dafoe\",\"arguments\":[{\"weight\":\"400\",\"subsets\":[\"latin\"],\"variable\":\"--font-pool\",\"display\":\"swap\"}],\"variableName\":\"mrdafoe\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"Instrument_Serif\",\"arguments\":[{\"weight\":\"400\",\"style\":\"italic\",\"subsets\":[\"latin\"],\"variable\":\"--font-quote\",\"display\":\"swap\"}],\"variableName\":\"instrumentserif\"}");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Block/effect-dots.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Block/effect-droplets.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Block/effect-stripes.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Block/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Footer/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Button/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Body/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Interactive/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/LoadingContent/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/SmartLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/index.scss");
